const removeFromCart = ({
  type,
  product,
  productLines,
  index,
  coupon,
  currency,
  id,
  isFree,
  productCategory2,
  productCategory3,
}) => {
  return () => {
    window.GTM.pushRemoveFromCart({
      type,
      product,
      productLines,
      index,
      coupon,
      currency,
      id,
      isFree,
      productCategory2,
      productCategory3,
    });
  };
};

export default removeFromCart;
